module.exports = __webpack_public_path__ + "static/media/Sec-4_2677_TH_Mobile.6bbec056.png";